export default "__VITE_ASSET__Bu8ldg1Z__"